import {Component, ElementRef, EventEmitter, Input, Output, ViewChild, ViewEncapsulation} from '@angular/core';
import {IdName} from '../../models/id-name.model';

@Component({
  selector: 'si-selector-icon',
  templateUrl: './selector-icon.component.html',
  styleUrls: ['./selector-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelectorIconComponent {
  @Input() items: IdName[] = [];
  @Input() styleClass: string;
  @Input() icon = 'icosun-filetext';
  @Input() iconClass: string;
  @Input() iconText: string;
  @Input() buttonMode = false;
  @Input() hideOnEmpty = false;
  @Input() openTop = false;
  @Output() modelChange = new EventEmitter<IdName>();
  @ViewChild('itemSelectorButton') itemSelectorButton: ElementRef;

  onClickIcon(event: Event): void {
    event.stopPropagation();
    event.preventDefault();
    if (this.items?.length === 1) {
      this.modelChange.emit(this.items[0]);
    } else {
      const clickEvent = new MouseEvent('click', {bubbles: true});
      this.itemSelectorButton.nativeElement.click(clickEvent);
    }
  }

  onSelectItem(item: IdName): void {
    this.modelChange.emit(item);
  }
}
